export const paths = {
  main: '/',
  search: '/search',
  validation: '/validation',
  crawlerInbox: '/crawler-inbox',
  statistics: '/statistics',
  crawlerOps: {
    main: '/crawler-ops',
    pipedrive: '/crawler-ops/pipedrive',
    mlStats: '/crawler-ops/ml-stats',
    signalTracking: '/crawler-ops/signal-tracking',
    userActivity: '/crawler-ops/user-activity',
    dashboard: '/crawler-ops/dashboard',
    enrichmentPerformance: '/crawler-ops/enrichment-performance',
    swClassifier: '/crawler-ops/sw-classifier',
    crawlQueue: '/crawler-ops/crawl-queue',
  },
  benchmarking: '/benchmarking',
  aiUpload: '/ai-upload',
  publicAnalysis: '/public-analysis',
  notifications: '/notifications',
  pipedriveActivity: '/notifications/pipedrive-activity',
  settings: '/settings',
  aiThreatDesign: '/settings/ai-threat-design',
  scheduledTasks: '/settings/scheduled-tasks',
  appInsight: '/settings/app-insight',

  evaluation: {
    evaluation: '/evaluation',
    customerSegment: '/customer-segment',
    dfm: '/evaluation/dfm',
    techAssessment: '/evaluation/tech-assessment',
    companyFiles: '/evaluation/company-files',
    marketResearch: '/evaluation/market-research',
    aiThreatIndex: '/evaluation/ai-threat-index',
    companyAnnotations: '/evaluation/company-annotations',
    marketSegments: '/evaluation/market-segments',
    bbLists: '/evaluation/bb-lists',
    startups: '/evaluation/startups',
    outreach: '/evaluation/outreach',
  },
  companyFinder: {
    softwareCategories: 'software-categories',
    customerIndustries: 'customer-industries',
    matrixSearch: 'matrix-search',
  },
  research: {
    valuationModel: '/research/valuation-model',
    industryBenchmarks: '/research/industry-benchmarks',
  },
  dealAnnouncements: '/deal-announcements',
  transactions: '/transactions',
  industryBenchmarks: '/industry-benchmarks',
  itSupport: '/it-support',
  validationV2: '/validation-v2',
  investorsGraph: '/investors-graph',
  survey: '/survey/:meetingId',
  meetings: '/meetings',
  admin: {
    questionnaires: '/admin/questionnaires',
  },
};
